import { useState } from 'react';
import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';
import ArrayFieldManager from '../components/ArrayFieldManager';

interface IxcTabProps {
  integration: Integration | null;
}

function IxcTab({ integration }: IxcTabProps) {
  const [osFinished, setOsFinished] = useState<number[]>(
    integration?.ixc_assunto_os_finished || []
  );
  const [osNewContract, setOsNewContract] = useState<number[]>(
    integration?.ixc_assunto_os_new_contract || []
  );
  const [osCancellation, setOsCancellation] = useState<number[]>(
    integration?.ixc_assunto_os_cancellation || []
  );
  const [osBudget, setOsBudget] = useState<number[]>(integration?.ixc_assunto_os_budget || []);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4 mb-6">
        <FormField>
          <FormLabel htmlFor="ixc_url">URL IXC</FormLabel>
          <FormInput id="ixc_url" name="ixc_url" defaultValue={integration?.ixc_url} />
        </FormField>

        <FormField>
          <FormLabel htmlFor="ixc_token">Token IXC</FormLabel>
          <FormInput id="ixc_token" name="ixc_token" defaultValue={integration?.ixc_token} />
        </FormField>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-6">
        <FormField>
          <FormLabel htmlFor="ixc_id_assunto">ID Assunto</FormLabel>
          <FormInput
            type="number"
            id="ixc_id_assunto"
            name="ixc_id_assunto"
            defaultValue={integration?.ixc_id_assunto}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="ixc_id_tecnico">ID Técnico</FormLabel>
          <FormInput
            type="number"
            id="ixc_id_tecnico"
            name="ixc_id_tecnico"
            defaultValue={integration?.ixc_id_tecnico}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="ixc_id_atendente">ID Atendente</FormLabel>
          <FormInput
            type="number"
            id="ixc_id_atendente"
            name="ixc_id_atendente"
            defaultValue={integration?.ixc_id_atendente}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="ixc_id_filial">ID Filial</FormLabel>
          <FormInput
            type="number"
            id="ixc_id_filial"
            name="ixc_id_filial"
            defaultValue={integration?.ixc_id_filial}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="ixc_id_setor">ID Setor</FormLabel>
          <FormInput
            type="number"
            id="ixc_id_setor"
            name="ixc_id_setor"
            defaultValue={integration?.ixc_id_setor}
          />
        </FormField>
      </div>

      {/* Seção de Arrays de IDs */}
      <div className="space-y-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 border-b pb-2">
          Configuração de Ordens de Serviço
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ArrayFieldManager
            label="IDs Assuntos OS Finalizados"
            name="ixc_assunto_os_finished"
            values={osFinished}
            onChange={setOsFinished}
            placeholder="ID do assunto para OS finalizada"
          />

          <ArrayFieldManager
            label="IDs Assuntos OS Novos Contratos"
            name="ixc_assunto_os_new_contract"
            values={osNewContract}
            onChange={setOsNewContract}
            placeholder="ID do assunto para novo contrato"
          />

          <ArrayFieldManager
            label="IDs Assuntos OS Cancelamentos"
            name="ixc_assunto_os_cancellation"
            values={osCancellation}
            onChange={setOsCancellation}
            placeholder="ID do assunto para cancelamento"
          />

          <ArrayFieldManager
            label="IDs Assuntos OS Orçamentos"
            name="ixc_assunto_os_budget"
            values={osBudget}
            onChange={setOsBudget}
            placeholder="ID do assunto para orçamento"
          />
        </div>
      </div>
    </div>
  );
}

export default IxcTab;
